import { useState, forwardRef, useImperativeHandle } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { Button } from 'react-bootstrap';
import { useAuth } from '../auth/AuthProvider';
import { updateAddress } from '../../controllers/user';
import { useToast } from '../toast/ToastContext';

const DireccionForm = forwardRef((props, ref) => {
  let [direccion, setDireccion] = useState(props.direccion?.direccion || '');
  let [direccion2, setDireccion2] = useState(props.direccion?.direccion2 || '');
  let [ciudad, setCiudad] = useState(props.direccion?.ciudad || '');
  let [estado, setEstado] = useState(props.direccion?.estado || '');
  let [zipCode, setZipCode] = useState(props.direccion?.zipCode || '');
  const { token } = useAuth();
  const showToast = useToast();
  
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState([]);

  function handleChange(e) {
    const value = e.target.value;
    switch (e.target.name) {
      case 'direccion': setDireccion(value); break;
      case 'direccion2': setDireccion2(value); break;
      case 'ciudad': setCiudad(value); break;
      case 'estado': setEstado(value); break;
      case 'zipCode': setZipCode(value); break;
    }
  }

  async function handleSearch(query) {
    if (query.length < 5) {
      return;
    }

    setIsLoading(true);
    const apiKey = 'ae7e3cd0f25a42ab8036908e0d371b4f';
    const search = encodeURIComponent(query);
    let url = `https://api.geoapify.com/v1/geocode/autocomplete?text=${search}&apiKey=${apiKey}`;
    let r = await fetch(url);
    let response = await r.json();
    setOptions(response.features.map(f => f.properties));
    setIsLoading(false);
  }
  const filterBy = () => true;

  function setAddress(address) {
    setSelectedAddress(address);
    if (!address.length) {
      return;
    }
    setDireccion(`${address[0].address_line1}`);
    setCiudad(address[0].city);
    setEstado(address[0].state_code);
    setZipCode(address[0].postcode);
  }

  useImperativeHandle(ref, () => ({
    getDireccion() {
      return generateAddress();
    }
  }));

  function generateAddress() {
    return {
      direccion,
      direccion2,
      ciudad,
      estado,
      zipCode,
      lat: selectedAddress.length ? selectedAddress[0].lat : null,
      lon: selectedAddress.length ? selectedAddress[0].lon : null
    };
  }

  async function submitUpdate() {
    let p = generateAddress();
    
    try {
      await updateAddress(token, props.userId, p);
      showToast({
        message: 'La dirección se actualizó con éxito.',
        bg: 'success',
        autohide: true,
        delay: 7000,
        title: 'Dirección actualizada'
      });
    }
    catch (e) {
      if (e.status === 400) {
        showToast({
          message: 'Ocurrió un error. Revisa la dirección y verifica que todo esté correcto.',
          bg: 'danger',
          autohide: true,
          delay: 7000,
          title: 'Error al actualizar dirección'
        });
      }
      else {
        showToast({
          message: 'Ocurrió un error. Por favor intenta de nuevo más tarde.',
          bg: 'danger',
          autohide: true,
          delay: 7000,
          title: 'Error al actualizar dirección'
        });
      }
    }
  }
  
  function renderSaveButton() {
    if (props.updateProfile) {
      return <Form.Group className="mb-3 submit-buttons-wrapper">
        <Button key='submit-btn-direccion' type='submit' variant='primary' onClick={submitUpdate}>Actualizar dirección</Button>
      </Form.Group>;
    }
  }

  return <Row>
    <Col>
      <AsyncTypeahead
        filterBy={filterBy}
        id="async-example"
        isLoading={isLoading}
        labelKey="formatted"
        minLength={3}
        onSearch={handleSearch}
        onChange={setAddress}
        options={options}
        placeholder="Busca tu dirección"
        renderMenuItemChildren={(option) => (
          <>
            <span>{option.formatted}</span>
          </>
        )}
        selected={selectedAddress}
      />
      <p>Autocomplete data from <a href="https://www.openstreetmap.org/copyright" target='_blank' rel="noopener noreferrer">©OpenStreetMap</a></p>

      <Form.Group className="mb-3 mt-5">
        <Form.Label>Dirección</Form.Label>
        <Form.Control type="text" placeholder="Dirección" value={direccion} name='direccion' onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Dirección 2</Form.Label>
        <Form.Control type="text" placeholder="Dirección 2" value={direccion2} name='direccion2' onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Ciudad</Form.Label>
        <Form.Control type="text" placeholder="Ciudad" value={ciudad} name='ciudad' onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Estado</Form.Label>
        <Form.Control type="text" placeholder="Estado" value={estado} name='estado' onChange={handleChange} maxLength={2} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>ZIP Code</Form.Label>
        <Form.Control type="text" placeholder="ZIP Code" value={zipCode} name='zipCode' onChange={handleChange} required />
      </Form.Group>

      {renderSaveButton()}
    </Col>
  </Row>;
});

export default DireccionForm;